import { takeLatest, call, put } from 'redux-saga/effects';
import * as homeActions from 'redux/ducks/Home/HomeDucks';
import portalApi from 'api/portal/portalApi';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* setHomeScreen({ payload }) {
  try {
    const response = yield call(portalApi.setHomeScreen, payload);
    yield put(homeActions.setHomeScreenSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
    yield put(homeActions.setHomeScreenFail(error));
  }
}

export default function* HomeSaga() {
  yield takeLatest(homeActions.setHomeScreen, setHomeScreen);
}
